import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { MarkdownView } from "@/components/MarkdownView";

export default function TermsOfService() {
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/public/consent-documents/terms_of_service")
            .then((r) => setDoc(r.data))
            .catch(() => setDoc(null))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="min-h-screen bg-phoenix-mesh">
            <div className="max-w-3xl mx-auto px-5 sm:px-6 py-12">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-phoenix-navy mb-8 transition-colors">
                    <ArrowLeft className="w-4 h-4" /> Back to App
                </Link>

                <div className="flex items-center gap-3 mb-2">
                    <div className="w-11 h-11 rounded-2xl bg-phoenix-navy text-white flex items-center justify-center">
                        <FileText className="w-5 h-5" />
                    </div>
                    <h1 className="font-display font-bold text-3xl text-phoenix-navy">{doc?.title || "Terms of Service"}</h1>
                </div>
                <p className="text-xs text-muted-foreground mb-10">Effective Date: {doc?.effective_date || "May 1, 2026"}</p>

                {loading ? (
                    <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-phoenix-navy" /></div>
                ) : (
                    <MarkdownView body={doc?.body} data-testid="terms-body" />
                )}

                <div className="border-t border-border pt-6 mt-10 text-xs text-muted-foreground">
                    <div className="flex gap-4">
                        <Link to="/privacy" className="text-phoenix-navy hover:underline">Privacy Policy</Link>
                        <Link to="/" className="text-phoenix-navy hover:underline">Return to App</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
